import { KAPLAYCtx } from "kaplay";
import { levels } from "./levels";

function make_home_page(k: KAPLAYCtx, levels_done: boolean[]) {
    for (let i = 0; i < levels.length; i++) {
        let pos = k.vec2(240 + 30 * i - 15 * levels.length, 240);
        let button = make_button(k, () => k.go("game", i), 20, 20, pos.x, pos.y, (i + 1).toString(), { outline: 2 });
        if (levels_done[i]) {
            button.color.r = 87;
            button.color.g = 202;
            button.color.b = 87;
        }
        button.onClick(() => {
            k.go("game", i);
        });
        button.onHover(() => {
            if (levels_done[i]) {
                button.color = k.rgb(97, 212, 97);
            }
            else {
                button.color = k.rgb(230, 230, 230);
            }
        })
        button.onHoverEnd(() => {
            if (levels_done[i]) {
                button.color = k.rgb(87, 202, 87);
            }
            else {
                button.color = k.rgb(255, 255, 255);
            }
        })
    }
}

function make_dialogue_cat(k: KAPLAYCtx, speech: string[], auto_open: boolean) {
    let cat = k.add([
        k.sprite("tutorial_cat"),
        k.pos(16 * 8, 16 * 10 + 8),
        k.layer("top"),
        k.area(),
        k.animate(),
    ]);
    let open = function () {
        cat.play("open");
        k.wait(1.4, () => k.play("grumpy_meow"));
        let text_box = k.add([
            k.sprite("text_box"),
            k.pos(16 * 4 + 8, 16 * 8),
            k.layer("ui"),
        ]);
        let index = 0;
        let speech_obj = k.add([
            k.text(speech[0], { font: "round", size: 6, width: 76 }),
            k.pos(16 * 4 + 12, 16 * 8 + 4),
            k.color(0, 0, 0),
            k.layer("ui"),
        ]);
        let buttons = [] as any[];
        buttons[0] = make_button(k, () => {
            index = Math.min(index + 1, speech.length - 1);
            speech_obj.text = speech[index];
            buttons[1].opacity = 1;
            buttons[1].get("*").forEach((b: any) => b.opacity = 1);
            if (index == 5 && !buttons[2]) {
                buttons[2] = k.add([
                    k.sprite("arrow_up"),
                    k.layer("furniture"),
                    k.pos(216, 186),
                    k.animate(),
                ]);
                buttons[2].animate("pos", [k.vec2(216, 186), k.vec2(216, 183)], { duration: 0.5, direction: "ping-pong", loops: 10000000 });
            }
            if (index == speech.length - 1) {
                k.play("grumpy_meow");
                cat.play("close");
                buttons[0].opacity = 0;
                buttons[0].get("*").forEach((b: any) => b.opacity = 0);
                k.wait(2, () => speech_obj.destroy());
                k.wait(2, () => text_box.destroy());
                k.wait(2, () => buttons[0].destroy());
                k.wait(2, () => buttons[1].destroy());
            }
        }, 7, 7, 142, 165, ">")
        buttons[1] = make_button(k, () => {
            buttons[0].opacity = 1;
            buttons[0].get("*").forEach((b: any) => b.opacity = 1);
            if (index == speech.length - 1) {
                cat.play("open");
            }
            index = Math.max(index - 1, 0);
            speech_obj.text = speech[index];
            if (index == 0) {
                buttons[1].opacity = 0;
                buttons[1].get("*").forEach((b: any) => b.opacity = 0);
            }
        }, 7, 7, 76, 165, "<");
        buttons[1].opacity = 0;
        buttons[1].get("*").forEach((b: any) => b.opacity = 0);

    };

    if (auto_open) {
        open();
    }
    else {
        let pos = k.vec2(cat.pos);
        cat.animate("pos", [pos, pos, pos, pos, pos, pos, pos.add(0, -1), pos, pos, pos, pos], { duration: 3, loops: 10000000 });
        let click_event = cat.onClick(() => {
            open();
            click_event.cancel();
        });
    }


}

function make_tutorial_cat(k: KAPLAYCtx) {
    let speech = [
        "EY YOU OVER THERE! NEED YOUR HELP",
        "TOBY IS ON THE BED. REALLY LAZY TODAY",
        "ALWAYS HAPPENS ON FIRST DAY OF FALL!",
        "HE LOST HIS MOTIVATION TO GET OUT OF BED",
        "CAN YOU HELP HIM FIND IT?",
        "DRAG ALL THE FOOD ONTO THE CARPET",
        "BE CAREFUL; HES A REALLY PICKY KITTY!",
        "OH AND SOMETIMES THE FOOD IS HIDDEN. SILLY OWNER!",
        "CIAO",
    ];
    make_dialogue_cat(k, speech, true);
}

function make_hint_cat(k: KAPLAYCtx, hint: string) {
    let speech = [
        "OI IM TRYNA CATCH A MOUSE IN HERE",
        "OH YOU NEED HELP?",
        (hint == "" ? "THIS ONES EASY. DO I LOOK LIKE A CHARITY?" : hint),
        "CIAO",
    ];
    make_dialogue_cat(k, speech, false);
}

function make_button(k: KAPLAYCtx, action: () => void, width: number, height: number, x: number, y: number, text: string, opts: { outline?: number } = {}) {
    let button = k.add([
        k.color(255, 255, 255),
        k.area(),
        k.rect(width, height),
        k.pos(x, y),
        k.opacity(1),
        k.layer("ui"),
    ]);
    if (opts.outline) {
        button.use(k.outline(opts.outline, k.rgb(0, 0, 0), 1, "bevel"));
    }
    button.add([
        k.color(0, 0, 0),
        k.text(text, { font: "round", size: 6, align: "center" }),
        k.pos(width / 2 - text.length * 3, height / 2 - 2),
        k.opacity(1),
        k.layer("ui"),
    ]);
    button.onHover(() => {
        button.color = k.rgb(230, 230, 230);
    });
    button.onHoverEnd(() => {
        button.color = k.rgb(255, 255, 255);
    });
    button.onClick(action);
    return button;
}

export { make_tutorial_cat, make_button, make_home_page, make_hint_cat };